const appId = 'nh9mlhmys2kaecrf';
const appSecret = '0MYM4wYO1kWUl3oiUfuMnR2SdOjS1w1p';

// 封装的函数，返回指定日期的节假日及万年历信息
async function getHolidayAndCalendarInfo(month) {
    const apiUrl = `https://www.mxnzp.com/api/holiday/list/month/${month}?ignoreHoliday=false&app_id=${appId}&app_secret=${appSecret}`;
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.code === 1) {
          return data.data;
      } else {
          console.error('接口返回错误:', data.msg);
          return null;
      }
    } catch (error) {
      console.error('请求失败:', error);
      return null;
    }
}

export default getHolidayAndCalendarInfo;

// // 示例使用
// const date = '20181121'; // 替换为需要查询的日期
// const appId = '你的app_id'; // 替换为你申请的app_id
// const appSecret = '你的app_secret'; // 替换为你申请的app_secret
// getHolidayAndCalendarInfo(date, appId, appSecret).then(result => {
//     if (result) {
//         console.log('日期:', result.date);
//         console.log('星期:', result.weekDay);
//         console.log('类型:', result.typeDes);
//         // 可根据需求继续打印其他信息
//     }
// });